import { Component, inject, input, OnChanges, signal, Input, OnInit, HostListener} from '@angular/core';
import { InventoryAction } from '../../../models/inventory_action.model';
import { AdminService } from '../../../admin/services/admin.service';
import { InventoryActionService } from '../../../services/inventory-action.service';
import { OrderComponent } from '../../../main/order/order.component';
import { BudgetViewComponent } from '../../../budget/budget-view/budget-view.component';
import { MatDialog } from '@angular/material/dialog';
import { InventoryActionDetailsComponent } from '../details/inventory-action-details.component';
import { toUnderscore } from '../../../utils/string-utils';

@Component({
    selector: 'app-inventory-action-row-details',
    templateUrl: './inventory-action-row-details.component.html',
    styleUrl: './inventory-action-row-details.component.scss',
    standalone: false
})
export class InventoryActionRowDetailsComponent implements OnChanges, OnInit {

  expanded = input<boolean>();

  loading = signal(false);

  inventoryActionId = input<number>();

  inventoryAction = signal<InventoryAction>(null);

  public readonly adminService = inject(AdminService);

  private readonly inventoryActionService = inject(InventoryActionService);

  private readonly matDialog = inject(MatDialog);

  @Input() evenRow = true;

  paginatedProducts: any[] = [];
  currentPage = 0;
  itemsPerPage = 0;
  totalPages = 0;


  constructor() { }

  ngOnInit(): void {
    this.calculateItemsPerPage();
    this.paginate();
  }

  ngOnChanges(changes) {
    if (changes.expanded && changes.expanded.currentValue) {
      this.loading.set(true);
      this.inventoryActionService.get(this.inventoryActionId()).subscribe((response) => {
        this.loading.set(true);
        if (!response) return;
        this.inventoryAction.set(response);

        this.calculateItemsPerPage();
        this.paginate();
      });
    }
    
  }

  openDocument(element) {
    const { document } = element;
    if (document.type === 'Order') {
      this.matDialog.open(OrderComponent, { data: document.id, minWidth: '80%' });
    } else if (document.type === 'Budget') {
      this.matDialog.open(BudgetViewComponent, { data: { id: document.id }, minWidth: '80%' });
    }
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.calculateItemsPerPage();
    this.paginate();
  }

  calculateItemsPerPage(): void {
    const availableWidth = window.innerWidth - 470;
    const itemsPerRow = Math.floor((availableWidth + 30) / (384 + 30));
    const itemsPerPage = itemsPerRow * 2; 
    this.itemsPerPage = itemsPerPage > 0 ? itemsPerPage : 1; 
    const inventoryProducts = this.inventoryAction()?.inventory_action_products?.filter(iap => iap.inventoriable) || [];
    this.totalPages = Math.ceil(inventoryProducts.length / this.itemsPerPage);
  }

  paginate(): void {
    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    const inventoryProducts = this.inventoryAction()?.inventory_action_products.filter(iap => iap.inventoriable) || [];
    this.paginatedProducts = inventoryProducts.slice(startIndex, endIndex);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.paginate();
    }
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.paginate();
    }
  }

  titleForType(type: string) {
    return this.adminService.getText(toUnderscore(type));
  }

  getTotalAmount(): number {
    return this.paginatedProducts.reduce((total, product) => total + (product.amount * product.quantity), 0);
  }
  

}
